import { DiabetesIcon } from './DiabetesIcon';

/**
 * author: Michael Richins
 * id B0973EC9-B27B-4666-8E9E-C766A601BB0A
 * name diabetes
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/diabetes.svg
 * tags
 * - Medical / Hospital 
 */
export const HandBloodIcon = DiabetesIcon;
export default HandBloodIcon